import {
  formDataToLocalizedString,
  LocalizedString,
  localizedStringToFormData,
} from '../common/localizedString';
import { KitchenFormData } from './kitchenFormData';

export interface KitchenFormModel {
  id?: string;
  name: LocalizedString;
}

export const toKitchenFormModel = (
  formData: KitchenFormData
): KitchenFormModel => {
  return {
    id: formData.id,
    name: formDataToLocalizedString(formData.names),
  };
};

export const toKitchenFormData = (model: KitchenFormModel): KitchenFormData => {
  return {
    id: model.id,
    names: localizedStringToFormData(model.name),
  };
};
